import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { Suspense } from 'react';

import { queryClient } from '../data/cache/queryClient';
import type { AppRouter } from './router';
import { Devtools } from './shell/Devtools';
import { ErrorBoundary } from './shell/ErrorBoundary';

export interface AppProps {
  router: AppRouter;
}

export function App({ router }: AppProps) {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        {Devtools && (
          <Suspense fallback={null}>
            <Devtools router={router} />
          </Suspense>
        )}
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
